import React from 'react';

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

// convert the degree to radian and tells how far is the point from cente : x or y axis dono par
const polarToCartesian = (cx, cy, r, angleDeg) => {
  const rad = (Math.PI / 180) * angleDeg;
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
};

// cx,cy are the center points of viewbox : drawing area inside svg
const describeArc = (cx, cy, r, startAngle, endAngle) => {
  const start = polarToCartesian(cx, cy, r, startAngle);
  const end = polarToCartesian(cx, cy, r, endAngle);
  const largeArcFlag = Math.abs(endAngle - startAngle) > 180 ? 1 : 0;
  const sweepFlag = 0;
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArcFlag} ${sweepFlag} ${end.x} ${end.y}`;
};

export function DashedProgress({
  value = 0,
  size = 96,
  strokeColor = '#767676',
  strokeThickness = 6,
  countBars = 100,
  // seam at bottom by default
  startAngle = 90,
  barWidth = 1,
  trailThickness = 0,
  trailColor = '#E5E7EB',
  textColor = '#334155'
}) {
  const clampedValue = clamp(value, 0, 100);
  const bars = Math.max(2, Math.floor(countBars));
  const filledBars = Math.round((clampedValue / 100) * bars);

  const viewBox = 100;
  const cx = viewBox / 2;
  const cy = viewBox / 2;
  const r = cx - strokeThickness;

  // Always use full 360°; value just decides how many segments are filled.
  const totalSweep = 360;
  const step = totalSweep / bars;
  const widthFactor = clamp(barWidth, 0.05, 1);

  const fontSize = Math.max(8, Math.round(size * 0.15));

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        flexShrink: 0
      }}
    >
      <svg
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        viewBox={`0 0 ${viewBox} ${viewBox}`}
      >
        {trailThickness > 0 &&
          Array.from({ length: bars }).map((_, i) => {
            const a0 = startAngle - i * step;
            const a1 = startAngle - (i + widthFactor) * step;
            return (
              <path
                key={`t-${i}`}
                d={describeArc(cx, cy, r, a0, a1)}
                fill="none"
                stroke={trailColor}
                strokeWidth={trailThickness}
                strokeLinecap="round"
              />
            );
          })}

        {Array.from({ length: bars }).map((_, i) => {
          const filled = i < filledBars;
          const a0 = startAngle - i * step;
          const a1 = startAngle - (i + widthFactor) * step;
          return (
            <path
              key={`p-${i}`}
              d={describeArc(cx, cy, r, a0, a1)}
              fill="none"
              stroke={filled ? strokeColor : 'transparent'}
              strokeWidth={strokeThickness}
              strokeLinecap="round"
            />
          );
        })}
      </svg>

      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize,
          fontWeight: 600,
          color: textColor,
          pointerEvents: 'none',
          whiteSpace: 'nowrap'
        }}
      >
        {Math.round(clampedValue)}%
      </span>
    </div>
  );
}

export default DashedProgress;
